export const Steps = (lmodule) => [
  {
    title: lmodule.getText("stepone"),
    count: 1,
    subTitle: lmodule.getText("subtext"),
  },
  {
    title: lmodule.getText("steptwo"),
    count: 2,
    subTitle: lmodule.getText("subtext"),
  },
  {
    title: lmodule.getText("stepthree"),
    count: 3,
    subTitle: lmodule.getText("subtext"),
  },
];
